import { h } from 'preact';

import Contest from './Contest';
import EmptyContest from '../components/EmptyContest';
import capitalize from '../utils/capitalize';

const Seat = ({ district, division_type, contests }) => {
  const isStatewide = division_type === 'statewide';

  return (
    <div class="seat">
      <h3 class="seat__title">
        {capitalize(division_type)}
        {district && !isStatewide && ` ${district}`}
      </h3>
      <div class="seat__contests">
        {contests.democrat ? (
          <Contest shouldIncludeMap contest={contests.democrat} />
        ) : (
          <EmptyContest party={'democrat'} />
        )}
        {contests.republican ? (
          <Contest shouldIncludeMap contest={contests.republican} />
        ) : (
          <EmptyContest party={'republican'} />
        )}
      </div>
    </div>
  );
};

export default Seat;



// WEBPACK FOOTER //
// ./componentsV2/Seat.js